import axios from '@/utils/apiClient'

const PAGE_SIZE = 200
const MAX_FILTER_IDS = 100

function enabledPermission (value) {
  return value === true || Number(value) === 1 ||
    ['true', 'yes', 'y'].includes(String(value || '').toLowerCase())
}

export async function loadNetxAssets (filters) {
  const batchKey = ['artwork_ids', 'ids'].find(key =>
    Array.isArray(filters[key]) && filters[key].length > MAX_FILTER_IDS
  )
  if (batchKey) {
    const batches = []
    for (let index = 0; index < filters[batchKey].length; index += MAX_FILTER_IDS) {
      const batchFilters = Object.assign({}, filters, {
        [batchKey]: filters[batchKey].slice(index, index + MAX_FILTER_IDS)
      })
      batches.push(loadNetxAssets(batchFilters))
    }
    const results = await Promise.all(batches)
    return [].concat(...results)
  }

  const assets = []
  let offset = 0
  let total = 0

  do {
    const response = await axios.get('/netx/assets', {
      params: Object.assign({}, filters, { limit: PAGE_SIZE, offset })
    })
    const page = response.data.assets || []
    total = response.data.total || 0
    assets.push(...page)
    offset += page.length
    if (page.length === 0) break
  } while (assets.length < total)

  return assets
}

export function updateNetxSelection (artworkId, assetId, desired) {
  return axios.put(
    `/netx/assets/${assetId}/selection`,
    Object.assign({ artwork_id: artworkId }, desired)
  )
}

export function startNetxArtworkImport (artworkId) {
  return axios.post('/netx/import_runs/artwork', { artwork_id: artworkId })
}

export function loadNetxImportRun (importRunId) {
  return axios.get(`/netx/import_runs/${importRunId}`)
}

export function updateArtworkPhotoPublicSelection (artworkId, photoId, selection) {
  return axios.put(
    `/artwork_photos/${photoId}/public_selection`,
    Object.assign({ artwork_id: artworkId }, selection)
  )
}

export function pendingSelection (asset, desired) {
  return Object.assign({}, asset.selection || {}, {
    status: 'queued',
    active: true,
    error: null,
    desired
  })
}

export function failedSelection (asset, message) {
  return Object.assign({}, asset.selection || {}, {
    status: 'failed',
    active: false,
    error: message
  })
}

export function selectionError (error) {
  return (error.response && error.response.data && error.response.data.error) ||
    'NetX image selection could not be updated.'
}

export function artworkImportError (error) {
  return (error.response && error.response.data && error.response.data.error) ||
    'NetX images could not be synced for this artwork.'
}

export function canManageNetx (user) {
  const currentUser = user || {}
  const roles = currentUser.roles || []
  const admin = enabledPermission(currentUser.admin) ||
    roles.some(role => ['admin', 'superadmin', 'root'].includes(String(role.shortcut || role.role || '').toLowerCase()))

  return admin || roles.some(role =>
    String(role.shortcut || role.role || '').toLowerCase() === 'netx_admin'
  )
}

export function canSyncNetx (user) {
  return canManageNetx(user)
}



// WEBPACK FOOTER //
// ./src/utils/netxArtworkReview.js